import { render, staticRenderFns } from "./WaterParaView.vue?vue&type=template&id=a54194f0&scoped=true&"
import script from "./WaterParaView.vue?vue&type=script&lang=js&"
export * from "./WaterParaView.vue?vue&type=script&lang=js&"
import style0 from "./WaterParaView.vue?vue&type=style&index=0&id=a54194f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54194f0",
  null
  
)

export default component.exports